export default __webpack_public_path__ + "static/VD_progress1-b5ed8c0a3290f606ddc2938eddc245be.jpg";